import React from "react";
import pdf from "../../Assets/pdfs/PLAN JACQUEMONT.pdf";

const Jacquemont = () => {
  return (
    <div
      style={{
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
      }}
    >
      <embed
        src={pdf}
        type="application/pdf"
        width="100%"
        height="100%"
      ></embed>
    </div>
  );
};

export default Jacquemont;
